import { render } from "./SiteNavigationOverlay.vue?vue&type=template&id=a97e20e8"
import script from "./SiteNavigationOverlay.vue?vue&type=script&lang=js"
export * from "./SiteNavigationOverlay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__